import React, { useState } from "react";
import bt from "../Components/Assets/bt.png";
import bc from "../Components/Assets/bc.png";
import ctp from "../Components/Assets/ctp.png";
import yeb from "../Components/Assets/yeebeto.png";
function Workspage(props) {
  const [showDes, setShowDes] = useState(false);

  const [work] = useState([
    {
      projectName: "BOTECH Website",
      des: "This is the official website for BOtech Developments a business which focussed on solving Information Technolgy issues. This website was develop with React  ",
      link: "https://www.botechdevelopments.com",
      img: bt,
      type:"website"
    },
    {
      projectName: "BECOMING CREATION Website",
      des: "This is the official website For Becoming Creation Limited A Uk base temporary recruitment agency. This website was develope with Nextjs",
      link: "https://www.becomingcreation.co.uk",
      img: bc,
      type:"website"
    },
    {
      projectName: "CovidTrack APP",
      des: " In the covid crisis I made an app that helps people to check updates on covid cases.I develop this mobile application with ionic",
      link: "",
      img: ctp,
      type:"mobile"
    }, {
      projectName: "YEEBETO VOTING APP",
      des: " I lead a team to develop this Desktop voting Application called yeebeto. This app was develop with tauri,React,chartjs,mongodb and standalone express api ",
      link: "",
      img: yeb,
      type:"desktop"
    },
  ]);
  return (
    <div id="works">
      {work.map((work,index) => (
        <section
          key={work.projectName}
          className="workcard"
          data-aos="fade-down"
        >
          <a href={work.link} target="_blank" rel="noreferrer" title="Click to visit or download">
            <img
              src={work.img}
              alt=""
              onMouseEnter={() => setShowDes(true)}
              onMouseOut={() => setShowDes(false)}
            />
          </a>
          <section
            className="describe"
            style={{
              visibility: showDes ? "visible" : "hidden",
              opacity: showDes?"1":"0",
            }}
            onMouseOut={() => setShowDes(false)}
            onMouseEnter={() => setShowDes(!showDes)}
          >
            <h1>{work.projectName}</h1>
            {work.des}
          </section>
        </section>
      ))}
    </div>
  );
}

export default Workspage;
